import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment'


@Injectable()
export class HelpService {
    constructor(private http: HttpClient) { }
    getFAQList() {
        return this.http.get(environment.restAPI + 'helpFAQList', {}).pipe(map((res: any) => res));

    }
    searchFAQList(data) {
        return this.http.get(environment.restAPI + 'searchHelpFAQ?searchValue=' + data, {}).pipe(map((res: any) => res));
    }
}
